import fetch from '../utils/fetch-json';

import {
    STARTED_TO_UPDATE_TRANSACTION,
    DID_UPDATE_TRANSACTION,
    FAILED_TO_UPDATE_TRANSACTION,
    DID_UPDATE_PROMOTED_GIVER,
    FAILED_TO_UPDATE_PROMOTED_GIVER,
    STARTED_TO_UPDATE_PROMOTED_GIVER,
    ADDING_ERROR_MODAL,
    DID_GET_TRANSACTION_FOR_GIVER_INFO,
    FAILED_TO_GET_TRANSACTION_FOR_GIVER_INFO,
    DID_DELETE_PROMOTED_GIVER,
    FAILED_TO_DELETE_PROMOTED_GIVER,
    STARTED_TO_DELETE_PROMOTED_GIVER,
    FETCHING_REWARDS_FOR_TRANSACTION,
    GOT_REWARDS_FOR_TRANSACTION,
    FETCHING_REWARDS_FOR_TRANSACTION_FAILED,
} from '../constants/index';
import { fetchProjectTransactions } from '../transaction/transaction-actions';
import { errorForFileUpload } from '../utils/error';

export function updateTransaction({
    transactionId,
    update_nonce,
    name,
    comment,
    anonymous,
    projectId,
    commentImageUrl,
}) {
    return ({ dispatch, getState }) => {
        dispatch({ type: STARTED_TO_UPDATE_TRANSACTION });
        const state = getState();
        const fullUrl = state.baseURL.concat(`/api/public/transaction/${transactionId}`);

        return fetch({
            url: fullUrl,
            options: {
                method: 'PUT',
                body: {
                    from_user_meta_data: {
                        name,
                        anonymous,
                    },
                    comment,
                    commentImageUrl,
                    update_nonce,
                },
            },
            dispatch,
            getState,
        })
            .then((response) => {
                const transaction = response.body.transaction;
                const comment = response.body.comment;
                dispatch(fetchProjectTransactions({ projectId, current: 0, count: 7 }));
                return dispatch({
                    type: DID_UPDATE_TRANSACTION,
                    projectId,
                    data: { transaction, comment },
                });
            })
            .catch((error) => {
                return Promise.reject(dispatch({ type: FAILED_TO_UPDATE_TRANSACTION, data: error.body }));
            });
    };
}

export const updateExternalGiverInfo =
    (transactionId, updateNonce, giverData, projectId) =>
    async ({ dispatch, getState }) => {
        dispatch({ type: STARTED_TO_UPDATE_TRANSACTION });
        const state = getState();
        const fullUrl = state.baseURL.concat(`/api/public/transaction/${transactionId}/external-user-data`);
        try {
            const response = await fetch({
                url: fullUrl,
                options: {
                    method: 'PUT',
                    body: {
                        externalFromUserMetadata: giverData,
                        updateNonce,
                    },
                },
                dispatch,
                getState,
            });
            return dispatch({
                type: DID_UPDATE_TRANSACTION,
                projectId,
                data: { transaction: response.body },
            });
        } catch (error) {
            return await Promise.reject(dispatch({ type: ADDING_ERROR_MODAL, data: error.body }));
        }
    };

export const checkIfUserHasMadeDecisionOnTax =
    ({ transactionId }) =>
    async ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = `${state.baseURL}/api/public/transaction/${transactionId}/madeDecisionOnTax`;
        try {
            const response = await fetch({
                url: fullUrl,
                options: {
                    method: 'GET',
                },
                dispatch,
                getState,
            });

            return response.body;
        } catch (error) {
            return error.body;
        }
    };

export const updatePromotedGiverInfo =
    (promotedGiverInfo, nonce) =>
    async ({ dispatch, getState }) => {
        dispatch({ type: STARTED_TO_UPDATE_PROMOTED_GIVER });
        const state = getState();
        const fullUrl = state.baseURL.concat(
            `/api/public/transaction/${promotedGiverInfo?.transaction_id}/promoted-giver-info`
        );
        try {
            const response = await fetch({
                url: fullUrl,
                options: {
                    method: 'PUT',
                    body: {
                        promotedGiverInfo,
                        nonce,
                    },
                },
                dispatch,
                getState,
            });
            return dispatch({
                type: DID_UPDATE_PROMOTED_GIVER,
                projectId: promotedGiverInfo?.project_id,
                data: { transaction: response.body },
            });
        } catch (error) {
            return dispatch({ type: FAILED_TO_UPDATE_PROMOTED_GIVER, data: error.body });
        }
    };

export const deletePromotedGiverInfo =
    (promotedGiverInfo, nonce) =>
    async ({ dispatch, getState }) => {
        dispatch({ type: STARTED_TO_DELETE_PROMOTED_GIVER });
        const state = getState();
        const fullUrl = state.baseURL.concat(
            `/api/public/transaction/${promotedGiverInfo?.transaction_id}/promoted-giver-info`
        );
        try {
            const response = await fetch({
                url: fullUrl,
                options: {
                    method: 'DELETE',
                    body: {
                        promotedGiverInfo,
                        nonce,
                    },
                },
                dispatch,
                getState,
            });
            return dispatch({
                type: DID_DELETE_PROMOTED_GIVER,
                projectId: promotedGiverInfo?.project_id,
                data: { transaction: response.body },
            });
        } catch (error) {
            return dispatch({ type: FAILED_TO_DELETE_PROMOTED_GIVER, data: error.body });
        }
    };

export const getTransaction =
    (transactionId, nonce) =>
    async ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = state.baseURL.concat(`/api/public/transaction/${transactionId}/${nonce}`);
        try {
            const response = await fetch({
                url: fullUrl,
                dispatch,
                getState,
            });
            return dispatch({
                type: DID_GET_TRANSACTION_FOR_GIVER_INFO,
                data: response.body,
            });
        } catch (error) {
            return dispatch({ type: FAILED_TO_GET_TRANSACTION_FOR_GIVER_INFO, data: error.body });
        }
    };

export const fetchBoughtRewardsForTransaction =
    (transactionId, transactionNonce) =>
    async ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = `${state.baseURL}/api/public/project/reward/transaction/${transactionId}/${transactionNonce}`;
        dispatch({ type: FETCHING_REWARDS_FOR_TRANSACTION });

        try {
            const response = await fetch({ url: fullUrl, dispatch, getState });
            const rewards = response.status !== 200 ? null : response.body.rewards;
            const orderMetadata = response.status !== 200 ? null : response.body?.orderMetadata;
            return dispatch({
                type: GOT_REWARDS_FOR_TRANSACTION,
                data: { rewards, orderMetadata, transactionId: parseInt(transactionId, 10) },
            });
        } catch (error) {
            return dispatch({ type: FETCHING_REWARDS_FOR_TRANSACTION_FAILED, data: error.body });
        }
    };

export const fetchLotteryTickets =
    ({ transactionId, transactionNonce }) =>
    async ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = state.baseURL.concat(
            `/api/public/transaction/${transactionId}/check-lottery-ticket/${transactionNonce}`
        );
        const response = await fetch({
            url: fullUrl,
            dispatch,
            getState,
        });
        return response.body;
    };

export const fetchPrizesForLotteryTickets =
    ({ transactionId, transactionNonce }) =>
    async ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = state.baseURL.concat(
            `/api/public/transaction/${transactionId}/check-lottery-prizes/${transactionNonce}`
        );
        const response = await fetch({
            url: fullUrl,
            dispatch,
            getState,
        });
        return response.body;
    };

export const markLotteryTicketRevealed =
    ({ lotteryTicketId, transactionNonce, transactionId }) =>
    async ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = state.baseURL.concat(`/api/public/transaction/lottery-ticket-checked/${lotteryTicketId}`);
        await fetch({
            url: fullUrl,
            options: {
                method: 'PUT',
                body: {
                    transactionId,
                    nonce: transactionNonce,
                },
            },
            dispatch,
            getState,
        });
    };

export const performSelfServeRefund =
    ({ refundCode, captchaToken }) =>
    async ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = state.baseURL.concat(`/api/public/transaction/self-serve-refund`);
        return await fetch({
            url: fullUrl,
            options: {
                method: 'POST',
                body: {
                    refundCode,
                    captchaToken,
                },
            },
            dispatch,
            getState,
        });
    };

export const uploadTransactionCommentImage =
    ({ projectId, file }) =>
    ({ dispatch, getState }) => {
        const state = getState();

        const fileValidationError = errorForFileUpload(file, state.transactionCommentImageMaxFileSize);

        if (fileValidationError !== null) {
            return Promise.reject(
                dispatch({
                    type: ADDING_ERROR_MODAL,
                    data: fileValidationError,
                })
            );
        }
        const fullUrl = state.baseURL.concat(`/api/public/transaction/comment-image/${projectId}`);

        const form = new FormData();
        form.append('image', file);

        return fetch({
            url: fullUrl,
            options: {
                method: 'POST',
                body: form,
                upload: true,
            },
            dispatch,
            getState,
        })
            .then((response) => response.body)
            .catch((error) => {
                return Promise.reject(dispatch({ type: ADDING_ERROR_MODAL, data: error.body }));
            });
    };

export const cropTransactionCommentImage =
    ({ projectId, uploadId, crop }) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = state.baseURL.concat(`/api/public/transaction/comment-image/${projectId}/${uploadId}`);
        return fetch({
            url: fullUrl,
            options: {
                method: 'PUT',
                body: {
                    crop,
                },
            },
            dispatch,
            getState,
        })
            .then((response) => response.body)
            .catch((error) => Promise.reject(dispatch(dispatch({ type: ADDING_ERROR_MODAL, data: error.body }))));
    };

export const previewTradingCard =
    ({ image, name, team, transactionId, transactionNonce }) =>
    ({ dispatch, getState }) => {
        const state = getState();
        if (!image) {
            return Promise.reject(
                dispatch({
                    type: ADDING_ERROR_MODAL,
                    data: { errors: { global: 'Mangler bilde.' } },
                })
            );
        }
        const form = new FormData();
        form.append('name', name);
        form.append('team', team);
        form.append('transactionNonce', transactionNonce);
        form.append('image', image);
        const fullUrl = state.baseURL.concat(`/api/public/transaction/${transactionId}/trading-card/preview`);
        return fetch({
            url: fullUrl,
            options: {
                method: 'POST',
                body: form,
                upload: true,
                timeout: 20000,
            },
            dispatch,
            getState,
        })
            .then((response) => response.body)
            .catch((error) => {
                return Promise.reject(dispatch({ type: ADDING_ERROR_MODAL, data: error.body }));
            });
    };

export const finalizeTradingCard =
    ({ cardPreviewId, cardPreviewTeamId, transactionId, transactionNonce, hidden, name }) =>
    ({ dispatch, getState }) => {
        const state = getState();
        const fullUrl = state.baseURL.concat(`/api/public/transaction/${transactionId}/trading-card/generate`);
        return fetch({
            url: fullUrl,
            options: {
                method: 'POST',
                body: {
                    previewPublicId: cardPreviewId,
                    team: cardPreviewTeamId,
                    transactionNonce,
                    hidden,
                    name,
                },
                timeout: 20000,
            },
            dispatch,
            getState,
        })
            .then((response) => response.body)
            .catch((error) => {
                return Promise.reject(dispatch({ type: ADDING_ERROR_MODAL, data: error.body }));
            });
    };
